export default __webpack_public_path__ + "static/media/messenger.9e7ad575.mp3";